import { useLocation } from "react-router-dom";

export function useQueryParams(): { [key: string]: string } {
  const location = useLocation();
  const params: { [key: string]: string } = {};
  const search = new URLSearchParams(location.search);
  search.forEach(function (value, key) {
    params[key] = value;
  });
  return params;
}

export function getQueryParam(params: { [key: string]: string }, key: string, defaultValue: string): string {
  if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
    return params[key];
  }
  return defaultValue;
}
